// app/lib/tracking/google-ads.ts

/**
 * Google Ads conversion event'i. Conversion label settings'ten gelir.
 */
export const trackAdsConversion = (params: {
  conversionLabel: string; // "AW-XXXXXXX/abcDEF" formatında tam değer
  value?: number;
  currency?: string;
  transactionId?: string;
}): void => {
  if (typeof window === "undefined" || typeof window.gtag !== "function")
    return;
  if (!params.conversionLabel) return;

  window.gtag("event", "conversion", {
    send_to: params.conversionLabel,
    value: params.value,
    currency: params.currency ?? "TRY",
    transaction_id: params.transactionId,
  });
};
